import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { personaChartData } from "@/data/landingData";

const PersonasSection = () => (
  <section id="personas" className="py-16 sm:py-24">
    <div className="container mx-auto px-5 sm:px-4">
      <div className="text-center mb-8">
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
          As <span className="text-gradient-green">12 Personas</span>
        </h2>
        <p className="text-sm sm:text-lg text-muted-foreground max-w-4xl mx-auto leading-relaxed">
          Todos nós possuímos as 12 Personas em nossa essência, mas elas exercem influências diferentes em cada indivíduo. Minhas personas têm pesos diferentes se comparadas as personas de quaisquer indivíduos no mundo.
          <br className="hidden sm:block" />
          Não existe alguém que tenha essência de estilo exatamente igual a sua.
        </p>
      </div>

      {/* Desktop chart */}
      <div className="w-full max-w-2xl mx-auto hidden sm:block">
        <ResponsiveContainer width="100%" height={480}>
          <PieChart>
            <Pie
              data={personaChartData}
              cx="50%"
              cy="50%"
              outerRadius={110}
              innerRadius={40}
              paddingAngle={2}
              dataKey="value"
              label={({ cx, cy, midAngle, outerRadius, name, percentage }) => {
                const RADIAN = Math.PI / 180;
                const radius = outerRadius + 60;
                const x = cx + radius * Math.cos(-midAngle * RADIAN);
                const y = cy + radius * Math.sin(-midAngle * RADIAN);
                const labelText = `${name} ${percentage}%`;
                const textWidth = labelText.length * 6;
                const anchor = x > cx ? "start" : "end";
                const rectX = anchor === "start" ? x - 4 : x - textWidth - 4;
                return (
                  <g>
                    <rect x={rectX} y={y - 10} width={textWidth + 8} height={20} rx={4} fill="hsl(222, 47%, 11%)" />
                    <text x={x} y={y} textAnchor={anchor} dominantBaseline="central" fill="#ffffff" fontSize={11} fontWeight={500}>
                      {labelText}
                    </text>
                  </g>
                );
              }}
              labelLine={false}
              startAngle={90}
              endAngle={-270}
            >
              {personaChartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name, props) => [`${(props as any).payload.percentage}%`, (props as any).payload.name]}
              contentStyle={{ backgroundColor: "hsl(222, 47%, 11%)", border: "1px solid hsl(217, 19%, 27%)", borderRadius: "8px", color: "#ffffff" }}
              labelStyle={{ color: "#ffffff" }}
              itemStyle={{ color: "#ffffff" }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Mobile chart — donut + legend */}
      <div className="w-full max-w-sm mx-auto block sm:hidden">
        <ResponsiveContainer width="100%" height={260}>
          <PieChart>
            <Pie
              data={personaChartData}
              cx="50%"
              cy="50%"
              outerRadius={100}
              innerRadius={40}
              paddingAngle={2}
              dataKey="value"
              startAngle={90}
              endAngle={-270}
            >
              {personaChartData.map((entry, index) => (
                <Cell key={`cell-m-${index}`} fill={entry.fill} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name, props) => [`${(props as any).payload.percentage}%`, (props as any).payload.name]}
              contentStyle={{ backgroundColor: "hsl(222, 47%, 11%)", border: "1px solid hsl(217, 19%, 27%)", borderRadius: "8px", color: "#ffffff" }}
              labelStyle={{ color: "#ffffff" }}
              itemStyle={{ color: "#ffffff" }}
            />
          </PieChart>
        </ResponsiveContainer>
        <div className="mt-4 space-y-2 px-2">
          {personaChartData.map((entry) => (
            <div key={entry.slug} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="inline-block h-3 w-3 rounded-full flex-shrink-0" style={{ backgroundColor: entry.fill }} />
                <span className="text-sm text-foreground">{entry.name}</span>
              </div>
              <span className="text-sm font-medium text-muted-foreground">{entry.percentage}%</span>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center mt-10 sm:mt-12">
        <Link to="/teste" className="btn-elegant inline-flex w-full sm:w-auto items-center justify-center gap-2">
          Descobrir Minhas Personas
          <ArrowRight className="w-5 h-5 shrink-0" />
        </Link>
      </div>
    </div>
  </section>
);

export default PersonasSection;
